import { z } from "zod";

import { branded } from "@/utils/branded-validation-utils";

export const sitePerimeterSchema = z.object({
  siteId: branded.v4hSiteId,
  siteName: z.string(),
});

export type TSitePerimeter = z.infer<typeof sitePerimeterSchema>;

export type TOrganizationPerimeter = {
  organizationId: number;
  organizationName: string;
  sites: TSitePerimeter[];
  children: TOrganizationPerimeter[];
};

export const organizationPerimeterSchema: z.ZodType<TOrganizationPerimeter> = z.object({
  organizationId: z.number(),
  organizationName: z.string(),
  sites: z.array(sitePerimeterSchema),
  children: z.lazy(() => organizationPerimeterSchema.array()),
});

export const userOrganizationPerimeterSchema = z.array(organizationPerimeterSchema);
